function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgIptu = function SvgIptu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.185 20.597H3.5v4.032h7.129v1h-7.21a.92.92 0 01-.919-.92v-4.193a.92.92 0 01.92-.92h2.015v-4.031H4.258a.92.92 0 01-.92-.92v-4.193a.92.92 0 01.92-.92h1.177V5.42a.92.92 0 01.92-.919H21.87a.92.92 0 01.92.92v2.596h-1V5.5H6.434v4.032h7.13v1H4.339v4.033h5.37a.5.5 0 010 1H6.436v4.032h2.936v1H6.185zm13.509 2.516h-.13c-.369 0-.88-.114-1.395-.457a2.75 2.75 0 01-.939-1.078.5.5 0 11.895-.447c.152.305.355.53.599.693.324.216.65.289.84.289h1.259c.761 0 1.387-.625 1.387-1.387s-.626-1.387-1.387-1.387h-1.258a2.393 2.393 0 01-2.388-2.387 2.393 2.393 0 012.388-2.387h.129v-.759a.5.5 0 111 0v.759h.129c.37 0 .88.113 1.395.456.386.257.707.614.939 1.078a.5.5 0 11-.895.447 1.752 1.752 0 00-.598-.693c-.325-.216-.652-.288-.841-.288h-1.258c-.762 0-1.388.625-1.388 1.387 0 .761.626 1.387 1.388 1.387h1.258a2.393 2.393 0 012.387 2.387 2.393 2.393 0 01-2.387 2.387h-.13v.758a.5.5 0 11-1 0v-.758zm9.806-4.274a9.306 9.306 0 11-18.613 0 9.306 9.306 0 0118.613 0zm-1 0a8.306 8.306 0 10-16.613 0 8.306 8.306 0 0016.613 0z"
  }));
};

SvgIptu.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgIptu.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgIptu;